export const kMainPageContentInfo = {
  data: {
    list: [
      "https://websiteimg.gnso.cn/wanfei-offical/main/banner2.png",
      "https://websiteimg.gnso.cn/wanfei-offical/main/banner1.png",
      "https://websiteimg.gnso.cn/wanfei-offical/main/banner3.png",
    ],
    texts: [
      "植物护肤就是芦荟",
      "芦荟就是万非",
    ],
    texts2: [
      "万非，就是芦荟！",
      "万非，又不只是芦荟！",
    ],
  },
};
